import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MainBodyBottomComponentService extends BaseApiService {

  constructor(protected injector: Injector) {
    super(injector);
  }

  public getHybrisTag(): Observable<any> {
    const endPoint = `${environment.baseApiUrls}/buildinfo`;
    return this.httpGet<any>(endPoint);
  }
}
